exports.linkResolver = (doc) => {
  if (doc.uid !== 'index' && doc.type === 'page') return `/${doc.uid}/`
  if (doc.uid === 'index' && doc.type === 'page') return `/`
  if (doc.type === 'blogpost') return `/blog/${doc.uid}/`
  return '/'
}
